// src/firebase/firebase.js

// Importaciones de Firebase
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Configuración de tu proyecto Firebase
const firebaseConfig = {
  apiKey: "AIzaSyCSpBjBpWzFZUYC_09JDKW6gZJ6tr_Dx5U",
  authDomain: "juani-pavlovsky-web.firebaseapp.com",
  projectId: "juani-pavlovsky-web",
  storageBucket: "juani-pavlovsky-web.firebasestorage.app",
  messagingSenderId: "991467416908",
  appId: "1:991467416908:web:651813ff93edc18334b3e9",
  measurementId: "G-5XVJZBEE76"
};

// Inicialización de Firebase
const app = initializeApp(firebaseConfig);

// Auth
const auth = getAuth(app);

// Firestore ✅
const db = getFirestore(app);

// Analytics (solo en navegador)
let analytics = null;
try {
  if (typeof window !== "undefined" && firebaseConfig.measurementId) {
    analytics = getAnalytics(app);

    // 👇 Habilita GA4 DebugView en desarrollo
    if (process.env.NODE_ENV === 'development' && window.gtag) {
      window.gtag('set', 'debug_mode', true);
    }
  }
} catch (e) {
  // En algunos entornos (extensiones, HTTP sin HTTPS) Analytics puede fallar.
  // Lo ignoramos para no romper la app.
  console.warn("Analytics no inicializado:", e);
}

export { app, auth, db, analytics };
